import apiClient from '../index';

export const pledgeApi = {
  // Get all pledges
  getPledges: () => apiClient.get('/pledges'),
  
  
  // Get pledge by ID
  getPledge: (id) => apiClient.get(`/pledges/${id}`),
  
  // Get pledges by event
  getPledgesByEvent: (eventId) => apiClient.get(`/pledges/event/${eventId}`),
  
  // Create new pledge
 createPledge: (data) => {
    // Ensure mobile is string before sending
    const formattedData = {
      ...data,
      mobile: String(data.mobile || ''),
      full_name: String(data.full_name || '')
    };
    return apiClient.post('/pledges', formattedData);
  },  
  // Update pledge
  updatePledge: (id, data) => apiClient.put(`/pledges/${id}`, data),
  
  // Delete pledge
  deletePledge: (id) => apiClient.delete(`/pledges/${id}`),
  
  // Update pledge amount collected
  updateAmountCollected: (id, amount) => apiClient.put(`/pledges/${id}/collect`, { amount_collected: amount }),

};

export default pledgeApi;
